var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddOutline28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.88 12.88h-6.76V6.12C15.12 5.505 14.617 5 14 5c-.616 0-1.12.504-1.12 1.12v6.76H6.12C5.505 12.88 5 13.383 5 14c0 .308.126.588.33.791.202.204.482.33.79.33h6.76v6.758c0 .308.125.589.329.792.203.203.483.329.791.329.616 0 1.12-.504 1.12-1.12v-6.76h6.76c.616 0 1.12-.504 1.12-1.12 0-.616-.504-1.12-1.12-1.12z"
  })));
}
export default SvgAddOutline28;